// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AnnouncementModalController from "./announcement_modal_controller"
import AutosizeTextareaController from "./autosize_textarea_controller"
import CommentActionsController from "./comment_actions_controller"
import CommentTimestampController from "./comment_timestamp_controller"
import MaxSessionController from "./max_session_controller"
import MaxWebappController from "./max_webapp_controller"
import ScrollBottomController from "./scroll_bottom_controller"
import ConvListController from "./conv_list_controller"
import InvestorDashboardFiltersController from "./investor_dashboard_filters_controller"
import CommentImageUploadController from "./comment_image_upload_controller"
import CommentImageController from "./comment_image_controller"
import FormSubmitLockController from "./form_submit_lock_controller"
import AdminShellController from "./admin_shell_controller"
import TurboLoaderController from "./turbo_loader_controller"

application.register("announcement-modal", AnnouncementModalController)
application.register("autosize-textarea", AutosizeTextareaController)
application.register("comment-actions", CommentActionsController)
application.register("comment-timestamp", CommentTimestampController)
application.register("max-session", MaxSessionController)
application.register("max-webapp", MaxWebappController)
application.register("scroll-bottom", ScrollBottomController)
application.register("conv-list", ConvListController)
application.register("investor-dashboard-filters", InvestorDashboardFiltersController)
application.register("comment-image-upload", CommentImageUploadController)
application.register("comment-image", CommentImageController)
application.register("form-submit-lock", FormSubmitLockController)
application.register("admin-shell", AdminShellController)
application.register("turbo-loader", TurboLoaderController)
